import React, { useRef, useEffect, forwardRef } from 'react';
import { Button, Flex } from '@chakra-ui/react';

const Tab = forwardRef(({ selected, title, onClick }, ref) => (
  <Button
    ref={ref}
    variant={selected ? 'solid' : 'ghost'}
    onClick={onClick}
    colorScheme={selected ? 'gray' : undefined}
    borderRadius="full"
    className="text-md font-medium py-0 px-4 h-8 flex-shrink-0"
    _hover={{
      background: selected ? 'gray.200' : 'gray.100',
    }}
  >
    {title}
  </Button>
));

const TabGroup = ({
  tabs,
  className,
}) => {
  const containerRef = useRef(null);
  const tabRefs = useRef([]);

  useEffect(() => {
    const selectedIndex = tabs.findIndex(tab => tab.selected);
    if (selectedIndex !== -1 && tabRefs.current[selectedIndex]) {
      tabRefs.current[selectedIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [tabs]);

  return (
    <Flex
      ref={containerRef}
      className={`w-[100vw] sm:w-full overflow-x-auto`}
    >
      <Flex className={`flex gap-2 w-fit ${className}`}>
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            ref={el => (tabRefs.current[index] = el)}
            title={tab.title}
            selected={tab.selected}
            onClick={tab.onClick}
          />
        ))}
      </Flex>
    </Flex>
  );
}

export {
  Tab,
  TabGroup,
}